/**
 * Brand icons that were dropped from the lucide icon set (and therefore from
 * @lucide/angular). Path data copied from lucide-angular 1.0.0 (ISC licence).
 */

import { LucideIconData } from '@lucide/angular';

export const FacebookIcon: LucideIconData = {
  name: 'facebook',
  node: [
    [
      'path',
      { d: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z', key: '1jg4f8' },
    ],
  ],
};

export const InstagramIcon: LucideIconData = {
  name: 'instagram',
  node: [
    ['rect', { width: '20', height: '20', x: '2', y: '2', rx: '5', ry: '5', key: '2e1cvw' }],
    ['path', { d: 'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z', key: '9exkf1' }],
    ['line', { x1: '17.5', x2: '17.51', y1: '6.5', y2: '6.5', key: 'r4j83e' }],
  ],
};

export const LinkedinIcon: LucideIconData = {
  name: 'linkedin',
  node: [
    [
      'path',
      {
        d: 'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z',
        key: 'c2jq9f',
      },
    ],
    ['rect', { width: '4', height: '12', x: '2', y: '9', key: 'mk3on5' }],
    ['circle', { cx: '4', cy: '4', r: '2', key: 'bt5ra8' }],
  ],
};

export const TwitterIcon: LucideIconData = {
  name: 'twitter',
  node: [
    [
      'path',
      {
        d: 'M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z',
        key: 'pff0z6',
      },
    ],
  ],
};
